import { Option } from 'funfix-core';
import { Record } from 'immutable';
import { FINISH_INSTALL_APP, INSTALL_APP_ERROR, START_INSTALL_APP } from '../../actions/Installation/InstallApp';
import { CLEAR_INSTALL_MODE, SET_INSTALL_MODE } from '../../actions/Installation/Installation';
import { FINISH_GENERATE_APP_SPECIFIC_PASSWORD, FINISH_REGENERATE_APP_SPECIFIC_PASSWORD, GENERATE_APP_SPECIFIC_PASSWORD_ERROR, REGENERATE_APP_SPECIFIC_PASSWORD_ERROR, SET_APP_SPECIFIC_PASSWORD_NAME, START_GENERATE_APP_SPECIFIC_PASSWORD, START_REGENERATE_APP_SPECIFIC_PASSWORD } from '../../actions/Installation/InstallMode/AppSpecificPassword';
import { DETERMINING_INSTALL_MODE_ERROR, FINISH_DETERMINING_INSTALL_MODE } from '../../actions/Installation/InstallMode/DeterminingInstallMode';
import { CLEAR_INSTALLABLE_APP_BY_MANUAL_URL, FETCH_INSTALLABLE_APP_BY_MANUAL_URL_ERROR, FINISH_FETCH_INSTALLABLE_APP_BY_MANUAL_URL, START_FETCH_INSTALLABLE_APP_BY_MANUAL_URL } from '../../actions/Installation/InstallMode/InstallableAppByManualUrl';
import { FETCH_INSTALLABLE_APP_FOR_UPGRADE_ERROR, FINISH_FETCH_INSTALLABLE_APP_FOR_UPGRADE, FINISH_UPGRADE_APP, START_UPGRADE_APP, UPGRADE_APP_ERROR } from '../../actions/Installation/UpgradeApp';
import installAppReducer from './InstallApp';
import appSpecificPasswordReducer from './InstallMode/AppSpecificPassword';
import determiningInstallModeReducer from './InstallMode/DeterminingInstallMode';
import installableAppByManualUrlReducer from './InstallMode/InstallableAppByManualUrl';
import upgradeAppReducer from './UpgradeApp';
export const makeInstallationState = Record({
  installMode: Option.none()
});

// eslint-disable-next-line complexity
export default function InstallationReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : makeInstallationState();
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SET_APP_SPECIFIC_PASSWORD_NAME:
    case START_GENERATE_APP_SPECIFIC_PASSWORD:
    case START_REGENERATE_APP_SPECIFIC_PASSWORD:
    case FINISH_GENERATE_APP_SPECIFIC_PASSWORD:
    case FINISH_REGENERATE_APP_SPECIFIC_PASSWORD:
    case GENERATE_APP_SPECIFIC_PASSWORD_ERROR:
    case REGENERATE_APP_SPECIFIC_PASSWORD_ERROR:
      return appSpecificPasswordReducer(state, action);
    case FINISH_DETERMINING_INSTALL_MODE:
    case DETERMINING_INSTALL_MODE_ERROR:
      return determiningInstallModeReducer(state, action);
    case START_FETCH_INSTALLABLE_APP_BY_MANUAL_URL:
    case FINISH_FETCH_INSTALLABLE_APP_BY_MANUAL_URL:
    case FETCH_INSTALLABLE_APP_BY_MANUAL_URL_ERROR:
    case CLEAR_INSTALLABLE_APP_BY_MANUAL_URL:
      return installableAppByManualUrlReducer(state, action);
    case START_INSTALL_APP:
    case FINISH_INSTALL_APP:
    case INSTALL_APP_ERROR:
      return installAppReducer(state, action);
    case FINISH_FETCH_INSTALLABLE_APP_FOR_UPGRADE:
    case FETCH_INSTALLABLE_APP_FOR_UPGRADE_ERROR:
    case START_UPGRADE_APP:
    case FINISH_UPGRADE_APP:
    case UPGRADE_APP_ERROR:
      return upgradeAppReducer(state, action);
    case SET_INSTALL_MODE:
      return state.set('installMode', Option.some(action.installMode));
    case CLEAR_INSTALL_MODE:
      return state.set('installMode', Option.empty());
    default:
      // Flow compile-time validation that we've handled every action
      // prettier-ignore
      action;
      return state;
  }
}